import { createContext, useContext } from 'react';

export type DialogMaxWidth = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;

export type DialogVariant = 'default' | 'confirmation' | 'alert' | 'fullScreen';

export interface DialogShellProps {
  maxWidth?: DialogMaxWidth;
  fullWidth?: boolean;
}

export interface Context {
  id: string;
  open: boolean;
  variant?: DialogVariant;
  onOpen: () => void;
  onClose: () => void;
  props: DialogShellProps;
  isLoading: boolean;
  isFullScreen: boolean;
  isFullScreenLayout: boolean;
  error?: Error;
}

export const DialogContext = createContext<Context>({
  id: '--dialog-composite-context-id--',
  open: false,
  variant: 'default',
  onOpen: () => {},
  onClose: () => {},
  props: {},
  isLoading: false,
  isFullScreen: false,
  isFullScreenLayout: false,
});

export const useDialogContext = () => {
  return useContext(DialogContext);
};
